import { Base } from "@/atoms-react/text/Text.react";
import confetti from "canvas-confetti";
import { useEffect, useState } from "react";

export const TestSentry = () => {
  const confettiExplosion = () => {
    const duration = 2 * 750;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 100 };

    const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

    const interval = window.setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 250 * (timeLeft / duration);

      confetti({
        ...defaults,
        particleCount: Math.floor(particleCount),
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      confetti({
        ...defaults,
        particleCount: Math.floor(particleCount),
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 150);
  };

  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      confettiExplosion();
      throw new Error("Booooooom!!");
    }
  });

  return (
    <div className="flex h-full w-full flex-row justify-center" role="alert">
      <div className="flex h-full flex-col justify-center" role="alert">
        {" "}
        <div>
          <Base className="w-full text-6xl text-primary">{seconds}</Base>
        </div>
      </div>
    </div>
  );
};
